/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React from "react";
import Heading from "../../components/Heading";
import DPPincodeList from "./DPPincodeList/DPPincodeList";
import { useLocation } from "react-router-dom";

const DPPincode = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const type = params.get("type");

  return (
    <div className="p-1">
      <Heading title={`DP Pincodes - ${type === "ECOMM" ? "Ecomm" : "Cargo"}`} />
      <div className="global-card-tab-container">
        <DPPincodeList type={type} />
      </div>
    </div>
  );
};

export default DPPincode;
